export const addHours = (date, h) => {
  const d = new Date(date);
  d.setTime(d.getTime() + h * 60 * 60 * 1000);
  return d;
};

export const addMinutes = (date, m) => {
  const d = new Date(date);
  d.setTime(d.getTime() + m * 60 * 1000);
  return d;
};

export const subtractMinutes = (date, m) => {
  const d = new Date(date);
  d.setTime(d.getTime() - m * 60 * 1000);
  return d;
};

export const isPast = (date) => {
  return new Date(date) < new Date();
};

export const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
};

/** Day 07:00–19:00, Night 19:00–07:00 (tasks / handover only). */
export const getCurrentShiftStart = (now = new Date()) => {
  const current = now instanceof Date ? new Date(now) : new Date(now);
  const hours = current.getHours();
  const shiftStart = new Date(current);

  if (hours >= 7 && hours < 19) {
    shiftStart.setHours(7, 0, 0, 0);
  } else if (hours >= 19) {
    shiftStart.setHours(19, 0, 0, 0);
  } else {
    shiftStart.setDate(shiftStart.getDate() - 1);
    shiftStart.setHours(19, 0, 0, 0);
  }

  return shiftStart;
};

/** Scheduled end of the current 12-hour shift. */
export const getCurrentShiftEnd = (now = new Date()) => {
  const shiftStart = getCurrentShiftStart(now);
  return addHours(shiftStart, 12);
};

/**
 * Notes window for shift handover compilation:
 * last 12 hours relative to shift end (i.e. the current shift), not by calendar date.
 */
export const getShiftHandoverNotesWindow = (now = new Date()) => {
  const shiftEnd = getCurrentShiftEnd(now);
  const windowStart = addHours(shiftEnd, -12);
  return { windowStart, shiftEnd };
};

export function isWithinShiftHandoverWindow(datetime, now = new Date()) {
  if (!datetime) return false;
  const value = datetime instanceof Date ? datetime : new Date(datetime);
  if (Number.isNaN(value.getTime())) return false;
  const { windowStart, shiftEnd } = getShiftHandoverNotesWindow(now);
  return value >= windowStart && value <= shiftEnd;
}
